<template>
  <div>{{ props.data }}</div>
</template>

<script setup lang="ts">
const props = defineProps<{ data: unknown }>();
const form = defineModel<any>("form", {
  default: () => ({}),
});
</script>

<style scoped></style>

